import { Navigate, Route, Routes } from 'react-router-dom';
import EditTemplatePage from '../../../../Pages/AdminAccount/EmployeesAdmin/EditTemplatePage';
import FilesImportPage from '../../../../Pages/AdminAccount/EmployeesAdmin/FileImportPage';

export const FileImportsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<FilesImportPage />} />
      <Route path="edit-template" element={<EditTemplatePage />} />
      <Route path="*" element={<Navigate to="/*" />} />
    </Routes>
  );
};
